export default "__VITE_ASSET__oStUVgnO__"